import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TableFilter } from 'src/app/models/TableFilter';
import { environment } from 'src/environments/environment';

import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class TableFilterService extends GenericService<TableFilter> {
  private internalHttp = inject(HttpClient);

  constructor() {
    super();
    this.setContext('tableFilters');
  }

  findAllByTable(table: string): Observable<TableFilter[]> {
    return this.internalHttp.get<TableFilter[]>(
      `${environment.apiUrl}/${this.context}/findAll/${table}`
    );
  }
}
